// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1oFTC","dragIcon":"SortableItem_dragIcon__2dPi8","disabled":"SortableItem_disabled__2tO-S"};